import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "IE6 can kiss my ass!",
  "description": "",
  "published": "2008-05-30T00:00:00.000Z",
  "redirect_from": ["/blog/ie6-can-kiss-my-ass/swizec/106"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yet again I've been asked to make a site work with IE6 and it's just fucking stupid that they ask of me to waste that much time on something as stupid. You don't ask an engineer to make a hydrogen car run on petrol just because petrol is around where people buy the car. You don't ask an engineer to make a diesel locomotive run on steam just because the owner has a bunch of wood to burn. You don't ask the whole world to write documents only in notepad because you're too lazy to install Office.`}</p>
    <p>{`For the love of god people, I don't give a fuck about an OLD browser. There's a new version and it's been out for TWO FUCKING years! If you still haven't bloody updated then it's your own fucking fault if the internet doesn't work for you.`}</p>
    <p>{`Next time my boss asks me to support IE6 I'm gonna tell them I won't do it and if they want it done they can just find somebody else to do it. Hell, I could get a better paying, but more stressful and farther away from home, job in a matter of days ... if they don't like my work, fine.`}</p>
    <p>{`They don't ask the designers to do their designs in MSPaint, so why should I be asked to do my work in an antique? If they (my boss) can go a week using only software from 2k1 and before then I'll gladly support IE6.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      